// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"475970d9","43":"8af9d61b","74":"44f50bd3","238":"62d9111d","267":"86e59500","345":"8792f3e6","412":"abe3d3c3","455":"366146ae","481":"893d3e92","621":"c99a295e","662":"44b0f45c","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};